import { tns } from "tiny-slider/src/tiny-slider";

window.addEventListener("load", () => {
  // This is for the nested phone links on the services page
  // Since nested <a> tags don't work, this is the workaround
  let phoneLinks = document.querySelectorAll("p.phone");
  for (let i = 0; i < phoneLinks.length; i++) {
    phoneLinks[i].addEventListener("click", function (e) {
      e.preventDefault();
      let link = phoneLinks[i].getAttribute("href");
      let clicker = document.createElement("a");
      clicker.setAttribute("href", link);
      clicker.click();
    });
  }

  // Hamburger
  document
    .querySelector("nav .hamburger")
    .addEventListener("click", function () {
      document.querySelector("nav.mobile").classList.add("open");
    });
  document.querySelector("nav .close").addEventListener("click", function () {
    document.querySelector("nav.mobile").classList.remove("open");
  });

  if (document.querySelector("body.page-template-services")) {
    // Services gallery functionality

    let featuredImg = document.querySelector(".img-feature");
    let galleryImgs = document.querySelectorAll(".gallery-imgs .img");
    for (let i = 0; i < galleryImgs.length; i++) {
      galleryImgs[i].addEventListener("click", function () {
        featuredImg.style.backgroundImage =
          galleryImgs[i].style.backgroundImage;
        featuredImg.classList.add("changeAnim");

        if (document.querySelector(".gallery-imgs .img.default")) {
          document
            .querySelector(".gallery-imgs .img.default")
            .classList.remove("default");
        }

        setTimeout(function () {
          featuredImg.classList.remove("changeAnim");
        }, 200);
      });
    }
  }

  // Highlight current service in navbar
  let service = window.location.href.split("/");
  if (service[3] == "services") {
    let link = `/${service[3]}/${service[4]}`;
    let navlinks = document.querySelectorAll(".hasdropdown .dropdown a");

    for (let i = 0; i < navlinks.length; i++) {
      if (navlinks[i].getAttribute("href") == link) {
        navlinks[i].classList.add("active");
      }
    }
  }
  //add active nav
  let url = window.location.href.split("/");
  let page = url[url.length - 2];
  if (url[3] == "") {
    page = "home";
  }
  let links = document.querySelectorAll(`[href='/${page}']`);
  if (links) {
    for (let i = 0; i < links.length; i++) {
      links[i].classList.add("active");
    }
  }

  // Contact Form
  let contact_form = document.getElementById("contact_form");
  if (contact_form) {
    function send_contact(form_data, callback) {
      let xr = new XMLHttpRequest();
      xr.open(
        "POST",
        "https://inform.prcr8.com/information@spokanerecovery.org"
      );
      xr.send(form_data);
      xr.addEventListener("load", (ev) => {
        callback(ev);
        contact_form.querySelector("[type='submit']").value = "Sent";
      });
    }

    contact_form.addEventListener("submit", (ev) => {
      ev.preventDefault();
      let form_data = new FormData(contact_form);
      contact_form
        .querySelectorAll("input, textarea")
        .forEach((el) => el.setAttribute("disabled", ""));
      contact_form.querySelector("[type='submit']").value = "Sending...";
      send_contact(form_data, (done) => {});
    });
  }

  if (document.querySelector("#testimonials .testimonials-slider") != null) {
    // Testimonials Slider
    var slider = tns({
      container: "#testimonials .testimonials-slider",
      items: 1,
      gutter: 30,
      navPosition: "bottom",
      navAsThumbnails: true,
      center: true,
      controlsContainer: "#testimonials .controls",
      responsive: {
        767: {
          items: 2,
          center: false,
        },
        1500: {
          items: 3,
          center: true,
        },
      },
    });
  }
  if (document.querySelector("#employee-testimonials .slider") != null) {
    // Employee Testimonials Slider
    var slider = tns({
      container: "#employee-testimonials .slider",
      items: 1,
      gutter: 30,
      navPosition: "bottom",
      navAsThumbnails: true,
      center: true,
      controlsContainer: "#employee-testimonials .controls",
    });
  }
});
//   // Employee Testimonials Slider
//   var slider = tns({
//     container: "#employee-testimonials .slider",
//     items: 1,
//     gutter: 30,
//     navPosition: "bottom",
//     navAsThumbnails: true,
//     center: true,
//     controlsContainer: "#employee-testimonials .controls",
//   });
// });
